<template lang="html">
<svg xmlns="http://www.w3.org/2000/svg" width="10.053" height="14.58" viewBox="0 0 10.053 14.58">
  <g id="streamline-icon-microphone-podcast-2_140x140" data-name="streamline-icon-microphone-podcast-2@140x140" transform="translate(0.5 0.5)">
    <path id="Path_44724" data-name="Path 44724" class="cls-1" d="M70,100.625v3.621" transform="translate(-65.473 -90.666)"/>
    <path id="Path_44725" data-name="Path 44725" class="cls-1" d="M52.5,135.625h3.621" transform="translate(-49.784 -122.045)"/>
    <path id="Path_44726" data-name="Path 44726" class="cls-1" d="M26.25,48.125v1.811a3.621,3.621,0,0,0,3.621,3.621h1.811A3.621,3.621,0,0,0,35.3,49.936V48.125" transform="translate(-26.25 -43.598)"/>
    <path id="Path_44727" data-name="Path 44727" class="cls-1" d="M47.344,12.523H45.533a1.931,1.931,0,0,1-1.811-2.037V6.412a1.931,1.931,0,0,1,1.811-2.037h1.811a1.931,1.931,0,0,1,1.811,2.037v4.074A1.931,1.931,0,0,1,47.344,12.523Z" transform="translate(-41.912 -4.375)"/>
  </g>
</svg>

</template>

<script>
export default {
  name: 'IconSalesSpeakBot',
};
</script>
<style lang="scss" scoped>
.cls-1 {
    fill: none;
    stroke: #fa0;
    stroke-linecap: round;
    stroke-linejoin: round;
}

</style>


